import React, { Component } from 'react';
import {
    Row, Col,
} from 'react-bootstrap';

class TitleAndMore extends Component {
    render() { 
        return (
            <div>
                <Row>
                    <Col xs="12" className="mb-4 mt-4 text-center">
                        <h1 className="subtitle-font">Edge.Poker</h1>
                        <h2 className="subsubtitle-font">Online Poker Odds Calculator, Analyzer & Helper for Texas Hold'Em</h2>
                    </Col>
                </Row>
            </div>

        )
    }

}

export default TitleAndMore;